import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LocalStorageKey, LocalStorageService } from '@auto-editor/data-access-local-storage';
import { environment } from '@auto-editor/environment';

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
  constructor(private localStorage: LocalStorageService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (typeof req.body === 'string' && req.body?.includes('refresh_token')) {
      return next.handle(req);
    }

    if (!this.isApiRequest(req.url) || req.headers.has('Authorization')) {
      return next.handle(req);
    }

    const rawOauthInfo = this.localStorage.getData(LocalStorageKey.oauthInfo);
    if (!rawOauthInfo) {
      return next.handle(req);
    }

    const storageOauthInfo = JSON.parse(rawOauthInfo);
    if (!storageOauthInfo?.access_token) {
      return next.handle(req);
    }

    const authReq = req.clone({
      headers: req.headers.append(
        'Authorization',
        `${storageOauthInfo.token_type} ${storageOauthInfo.access_token}`
      )
    });
    return next.handle(authReq);
  }

  private isApiRequest(url: string): boolean {
    return (
      url.startsWith(environment.serverApi) ||
      url.startsWith(environment.serverBackend)
    );
  }
}
